export const SERVICE_MODES = {
    MESH: 'mesh',
    SFU: 'sfu'
};